import { useLocation, Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { useTranslation } from "@/contexts/LanguageContext";
import { getRecommendedNext } from "@/data/learningPath";

// Auto-rendered strip at the bottom of every lesson page. Reads the current
// route and suggests the next 2 lessons in the curated learning path.
// Renders nothing on non-lesson routes (Dashboard, login, etc.).
export default function RecommendedNext() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const next = getRecommendedNext(pathname, 2);
  if (next.length === 0) return null;

  return (
    <section
      className="print:hidden max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 pt-4"
      data-testid="recommended-next"
    >
      <div className="border-t border-white/10 pt-8">
        <p className="text-[#F5A524] text-xs uppercase tracking-[0.2em] mb-1">
          {t("rec_next_eyebrow")}
        </p>
        <h2 className="font-['Outfit'] text-white text-xl font-semibold mb-4">
          {t("rec_next_title")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {next.map(({ to, labelKey, Icon }, i) => (
            <motion.div
              key={to}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: i * 0.06 }}
            >
              <Link
                to={to}
                data-testid={`rec-next-${to.replace(/\//g, "")}`}
                className="group flex items-center gap-3 bg-[#121214]/80 backdrop-blur-md border border-white/10 rounded-xl p-4 hover:border-[#F5A524]/40 hover:-translate-y-0.5 transition-all duration-200"
              >
                <span className="w-10 h-10 rounded-lg flex items-center justify-center bg-[#F5A524]/10 shrink-0">
                  <Icon weight="fill" className="w-5 h-5 text-[#F5A524]" />
                </span>
                <span className="flex-1 text-white font-medium text-sm leading-snug">
                  {t(labelKey)}
                </span>
                <ArrowRight className="w-4 h-4 text-[#52525B] group-hover:text-[#F5A524] group-hover:translate-x-0.5 transition-all" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
